import { render, staticRenderFns } from "./ExercisesChart.vue?vue&type=template&id=696295c6&scoped=true"
import script from "./ExercisesChart.vue?vue&type=script&lang=js"
export * from "./ExercisesChart.vue?vue&type=script&lang=js"
import style0 from "./ExercisesChart.vue?vue&type=style&index=0&id=696295c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696295c6",
  null
  
)

export default component.exports